module.exports = _.findLastIndex;